<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid ref='refSalesStatusListGrid'
        :data-source='salesStatusList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :auto-navigate-to-focused-row="false"
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="판매가"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          :allowEditing='false'
          caption="고객사"
          data-field="납품처코드"
          sort-order="asc"
        >
          <DxLookup
            :data-source="customerLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          alignment="center"
          caption="매출현황"
        >
          <DxColumn
            :allowEditing='false'
            caption="예상매출액"
            data-field="예상매출액"
            format='#,##0'
            dataType="number"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            alignment='right'
            caption="점유율%"
            :calculate-cell-value="calc점유율"
            format='#,##0'
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="납입매출액"
            data-field="납입매출액"
            format='#,##0'
            dataType="number"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            alignment='right'
            caption="매출달성율(%)"
            data-field="매출달성율"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="계산서"
            data-field="계산서금액"
            format='#,##0'
            dataType="number"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            alignment='right'
            caption="계산서달성율(%)"
            data-field="계산서달성율"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="부가액(걔산서기준)"
            data-field="계산서부가액"
            format='#,##0'
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            alignment='right'
            caption="부가율"
            data-field="부가율"
            :visible='true'
          >
          </DxColumn>
        </DxColumn>
        <DxSummary :calculate-custom-summary="calculateSelectedRow">
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="예상매출액"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="납입매출액"
            display-format="{0}"
          />
          <DxTotalItem
            name="TotalRateSummary"
            summary-type="custom"
            value-format='#0.#%'
            column="매출달성율"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="계산서금액"
            display-format="{0}"
          />
          <DxTotalItem
            name="TotalBillRateSummary"
            summary-type="custom"
            value-format='#0.#%'
            column="계산서달성율"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="계산서부가액"
            display-format="{0}"
          />
          <DxTotalItem
            name="TotalSurchargeRateSummary"
            summary-type="custom"
            value-format='#0.#%'
            column="부가율"
            display-format="{0}"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel,
  DxLookup } from 'devextreme-vue/data-grid'
import AppLib from '../../share/AppLib'

export default {
  name: 'salseStatus',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '부품 매출 현황'
        }
      ],
      customerLookup: [],
      salesStatusList: [],
      salesDateBox: null,
      salesDate: null,
      total예상매출액: null,
      total납입매출액: null,
      total계산서금액: null,
      total부가액: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.salesDate = `${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01`
    this.customerLookup = this.$store.getters.getCustomerInfo
    this.refreshSalesStatus()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calculateSelectedRow (options) {
      if (options.name === 'TotalRateSummary') { // 매입 / 납입
        if (options.summaryProcess === 'finalize') {
          options.totalValue = this.total납입매출액 / this.total예상매출액
        }
      } else if (options.name === 'TotalBillRateSummary') { // 계산서 / 납입
        if (options.summaryProcess === 'finalize') {
          options.totalValue = this.total계산서금액 / this.total예상매출액
        }
      } else if (options.name === 'TotalSurchargeRateSummary') { // 계산서 / 납입
        if (options.summaryProcess === 'finalize') {
          options.totalValue = this.total부가액 / this.total예상매출액
        }
      }
    },
    calc점유율 (e) {
      return `${Math.round(e.예상매출액 / this.total예상매출액 * 100)}%`
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준월:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.salesDate,
            type: 'date',
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            },
            displayFormat: 'yyyy-MM',
            onInitialized: (args) => {
              this.salesDateBox = args.component
            },
            onValueChanged: (args) => {
              this.salesDate = args.value
              this.refreshSalesStatus()
            }
          }
        }
      )
    },
    refreshSalesStatus () {
      const splitDate = this.salesDate.split('-')
      let param = {
        fromDate: `${this.salesDate}`,
        toDate: `${splitDate[0]}-${splitDate[1]}-${AppLib.getMonthLastDay(splitDate[0], splitDate[1])} 23:59:59`
      }
      this.$_sp.runNoEncodeFindProc('spFindAllSalesStatusByDate', param)
        .then((data) => {
          this.isLoading = false
          this.salesStatusList = this.$_sp.MakeModel(data)
          this.salesStatusList.forEach(item => {
            this.total예상매출액 += item.예상매출액
            this.total납입매출액 += item.납입매출액
            this.total계산서금액 += item.계산서금액
            this.total부가액 += item.계산서부가액
          })
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
